// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import moment from 'moment'
import App from './App.vue'
import router from './router'
import { Tooltip, Button, Icon } from 'element-ui'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import frlocale from 'element-ui/lib/locale/lang/fr'
import enlocale from 'element-ui/lib/locale/lang/fr'

Vue.use(VueI18n)
const messages = {
  fr: {
    message: 'bonjour',
    ...frlocale // Or use `Object.assign({ message: 'hello' }, enLocale)`
  },
  en: {
    message: 'hello',
    ...enlocale // Or use `Object.assign({ message: '你好' }, zhLocale)`
  }
}
const i18n = new VueI18n({
  locale: 'fr',
  messages
})

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
// si la taille du app.js devient problématique, il sera toujours possible de charge les composants element-ui plus parcimonieusement:
// Vue.use(Input)
// Vue.use(Tooltip)
// Vue.use(Button)
// Vue.use(Icon)

window.$http = Vue.prototype.$http = axios

Vue.prototype.moment = moment
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js